import { LinkedChainNavigation } from 'components/linkedChainNavigation/linkedChainNavigation'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { RootState } from 'stores'
import { ActionType } from 'typesafe-actions'
import { navigate } from './actions'
import { HorizontalNavigation as Component } from './component'
import { createSelector } from 'reselect'

const getCurrentPath = (state: RootState) => state.router.location.pathname

const getAnswers = (state: RootState) => state.answers

const calculateUnansweredQuestions = createSelector(
  getAnswers,
  answers => {
    if (answers.length > 0 && answers.includes(undefined)) {
      return `/question/${answers.findIndex(
        answer => typeof answer === 'undefined'
      ) + 1}`
    }

    return undefined
  }
)

const mapStateToProps = (state: RootState) => ({
  links: new LinkedChainNavigation(getCurrentPath(state)),
  unansweredQuestion: calculateUnansweredQuestions(state)
})

const mapDispatchToProps = (
  dispatch: Dispatch<ActionType<typeof navigate>>
) => ({
  navigateBack: () => dispatch(navigate(-1)),
  navigateForward: () => dispatch(navigate(1))
})

export const HorizontalNavigation = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component)
